import { createContext } from 'react';
import type { IndicatorEntry } from '@/data/hook/shared/dnd/useDragPlaceholder';

const DragIndicatorContext = createContext<{
  indicator: IndicatorEntry;
  parentId: string;
}>({ indicator: null, parentId: '' });

export default DragIndicatorContext;
